<div *ngIf="qsForm" [formGroup]="qsForm" class="grid-container">
    <div>
        <div class="list-digit__target grid-container question-title question-title--no-top">
            <div class="grid-9 grid-mobile-4">
                <h3 class="hide show-mobile section-title">
                    {{ 'medicalworkflow.question.heightWeightQuestion.title' | i18n }}
                </h3>
            </div>
            <div class="grid-12 grid-mobile-4 grid-container">
                <div>
                    <label [for]="questionQuestionnaireSante.numero + 'Height'" class="question-height">
                        <span class="question-height__begin">
                            <span class="hide-mobile">{{ 'medicalworkflow.question.heightWeightQuestion.height.begin' | i18n }} </span>
                            <span class="hide show-mobile">{{ 'medicalworkflow.question.heightWeightQuestion.height.begin.mobile' | i18n }}</span>
                        </span>
                        <span class="question-height__answers">
                            <input type="number" [id]="questionQuestionnaireSante.numero + 'Height'" [formControlName]="questionQuestionnaireSante.numero + 'Height'" class="textfield textfield--tiny" min="50" max="299" required />
                            <span class="question-height__end"> {{ 'medicalworkflow.question.heightWeightQuestion.height.end' | i18n }}</span>
                        </span>
                    </label>
                    <label [for]="questionQuestionnaireSante.numero + 'Weight'" class="question-weight">
                        <span class="question-weight__begin">
                            <span class="hide-mobile"> {{ 'medicalworkflow.question.heightWeightQuestion.weight.begin' | i18n }} </span>
                            <span class="hide show-mobile">{{ 'medicalworkflow.question.heightWeightQuestion.weight.begin.mobile' | i18n }}</span>
                        </span>
                        <span class="question-weight__answers">
                            <input type="number" [id]="questionQuestionnaireSante.numero + 'Weight'" [formControlName]="questionQuestionnaireSante.numero + 'Weight'" class="textfield textfield--tiny" min="20" max="500" required />
                            <span class="question-weight__end"> {{ 'medicalworkflow.question.heightWeightQuestion.weight.end' | i18n }}</span>
                        </span>
                    </label>
                </div>
            </div>
        </div>
    </div>
</div>
